import { Component, OnInit } from "@angular/core";
import { AppConfig } from 'src/app/app-config';
import { JsLoaderService } from "./../../../shared/services/js-loader.service";

@Component({
  selector: "app-account",
  templateUrl: "./account.component.html"
})
export class AccountComponent implements OnInit {
  constructor(private jsLoader: JsLoaderService, private config: AppConfig) { }
  contactUsPagePath = this.config.ContactUsPage;
  IsPortal = this.config.IsPortal;
  EarthMedUserAccountManagementGuidePath;
  EarthMedUserAccountManagementVideoPath;
  EMUAMUserGuidePath;

  HoSReportPath = this.config.HoSReport;

  ngOnInit() {
    this.jsLoader.loadScripts();

    if (!this.IsPortal) {
      this.EarthMedUserAccountManagementGuidePath = this.config.EarthMedUserAccountManagementGuideURL;
      this.EarthMedUserAccountManagementVideoPath = this.config.EarthMedUserAccountManagementVideo;
      this.EMUAMUserGuidePath = this.config.EMUAMUserGuide;
    }
  }
}
